import React, { useRef } from "react";
import Header from "../index/Header";
import Footer from "../index/Footer";


export default function PoliticaPrivacidad() {
    const scrollRef = useRef();
    return (
        
            <div className="relative font-cinzel text-eryndra-cream bg-eryndra-forest bg-cover bg-center min-h-screen overflow-hidden py-10">

                <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />
                <section class="max-w-4xl mx-auto p-6 text-eryndra-cream">
                    <h1 class="text-4xl font-cinzel text-eryndra-gold mb-4">Política de Cookies</h1>

                    <p class="mb-4 font-bellefair text-xl">Este sitio web, propiedad de Eryndra Eventos, utiliza cookies propias para garantizar el correcto funcionamiento de la web.</p>

                    <h2 class="text-2xl font-bold text-eryndra-gold mb-2">¿Qué son las cookies?</h2>
                    <p class="mb-4 font-bellefair text-xl">Una cookie es un pequeño archivo de texto que se almacena en tu navegador cuando visitas una página web. Su finalidad es facilitar la navegación, personalizar contenidos o recoger información estadística anónima.</p>

                    <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Cookies utilizadas</h2>
                    <p class="mb-4 font-bellefair text-xl">Actualmente, esta web solo utiliza cookies técnicas necesarias para su funcionamiento. No se emplean cookies de análisis, publicidad ni seguimiento.</p>

                    <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Gestión de cookies</h2>
                    <p class="mb-4 font-bellefair text-xl">Puedes permitir, bloquear o eliminar las cookies instaladas en tu dispositivo mediante la configuración de las opciones del navegador que estés utilizando. Ten en cuenta que si desactivas las cookies, es posible que la web no funcione correctamente.</p>

                    <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Cambios en la política de cookies</h2>
                    <p class="mb-4 font-bellefair text-xl">Esta política podrá actualizarse en función de cambios legislativos o técnicos. Te recomendamos revisarla periódicamente.</p>

                    <p class="mt-4">Última actualización: junio de 2025.</p>
                </section>

                <Footer />
            </div>

    );
}